/**
 * Сигнал «аккаунт заблокирован» из axios-интерцептора в React-дерево.
 *
 * Устроено как appLock: интерцептор — единственное место, где о блокировке
 * узнают все запросы разом, а показать окно должен корень приложения. Тащить
 * это состояние через каждый вызов api.get значило бы дописать обработку в
 * каждую страницу и всё равно пропустить половину.
 *
 * Флаг держится в модуле, а не только в состоянии React: запрос, прилетевший
 * до монтирования подписчика, иначе потерялся бы, и человек увидел бы пустой
 * экран вместо объяснения.
 */

let blocked = null;

const listeners = new Set();

/** Что известно о блокировке: null — не заблокирован. */
export const getAccountBlock = () => blocked;

export const onAccountBlocked = (cb) => {
  listeners.add(cb);
  // Блокировка могла прийти раньше подписки — отдаём её сразу.
  if (blocked) {
    try {
      cb(blocked);
    } catch {
      /* noop */
    }
  }
  return () => listeners.delete(cb);
};

export const notifyAccountBlocked = (detail) => {
  const next = {
    message: String(detail?.message || "").trim(),
  };
  // Повторные 403 по каждому фоновому запросу — норма: окно уже показано,
  // будить дерево на каждый из них незачем.
  if (blocked) return;
  blocked = next;
  for (const cb of listeners) {
    try {
      cb(next);
    } catch {
      /* noop */
    }
  }
};

/** Признак блокировки в ответе сервера. Разбор один на всё приложение. */
export const isAccountBlockedError = (error) => {
  if (Number(error?.response?.status || 0) !== 403) return false;
  const detail = error?.response?.data?.detail;
  if (!detail || typeof detail !== "object") return false;
  return String(detail.code || "") === "account_blocked";
};
